import { useEffect } from "react";

function PrivacyDidomi({ configCode, onDidomiReady }) {
  useEffect(() => {
    const initializeDidomi = () => {
      if (document.getElementById("spcloader")) return;

      if (configCode === "onair.ma") {
        (function () {
          function i(e) {
            if (!window.frames[e]) {
              if (document.body && document.body.firstChild) {
                var t = document.body;
                var n = document.createElement("iframe");
                n.style.display = "none";
                n.name = e;
                n.title = e;
                t.insertBefore(n, t.firstChild);
              } else {
                setTimeout(function () {
                  i(e);
                }, 5);
              }
            }
          }
          function e(n, o, r, f, s) {
            function e(e, t, n, i) {
              if (typeof n !== "function") {
                return;
              }
              if (!window[o]) {
                window[o] = [];
              }
              var a = false;
              if (s) {
                a = s(e, i, n);
              }
              if (!a) {
                window[o].push({ command: e, version: t, callback: n, parameter: i });
              }
            }
            e.stub = true;
            e.stubVersion = 2;
            function t(i) {
              if (!window[n] || window[n].stub !== true) {
                return;
              }
              if (!i.data) {
                return;
              }
              var a = typeof i.data === "string";
              var e;
              try {
                e = a ? JSON.parse(i.data) : i.data;
              } catch (t) {
                return;
              }
              if (e[r]) {
                var o = e[r];
                window[n](
                  o.command,
                  o.version,
                  function (e, t) {
                    var n = {};
                    n[f] = { returnValue: e, success: t, callId: o.callId };
                    if (i.source) {
                      i.source.postMessage(a ? JSON.stringify(n) : n, "*");
                    }
                  },
                  o.parameter
                );
              }
            }
            if (typeof window[n] !== "function") {
              window[n] = e;
              if (window.addEventListener) {
                window.addEventListener("message", t, false);
              } else {
                window.attachEvent("onmessage", t);
              }
            }
          }
          e("__tcfapi", "__tcfapiBuffer", "__tcfapiCall", "__tcfapiReturn");
          i("__tcfapiLocator");
          (function (e, r) {
            var t = document.createElement("link");
            t.rel = "preconnect";
            t.as = "script";
            var n = document.createElement("link");
            n.rel = "dns-prefetch";
            n.as = "script";
            var i = document.createElement("script");
            i.id = "spcloader";
            i.type = "text/javascript";
            i["async"] = true;
            i.charset = "utf-8";
            var o =
              "https://sdk.privacy-center.org/" +
              e +
              "/loader.js?target_type=notice&target=" +
              r;
            if (window.didomiConfig && window.didomiConfig.user) {
              var a = window.didomiConfig.user;
              var c = a.country;
              var d = a.region;
              if (c) {
                o = o + "&country=" + c;
                if (d) {
                  o = o + "&region=" + d;
                }
              }
            }
            t.href = "https://sdk.privacy-center.org/";
            n.href = "https://sdk.privacy-center.org/";
            i.src = o;
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(t, s);
            s.parentNode.insertBefore(n, s);
            s.parentNode.insertBefore(i, s);
          })("af22b044-c2d8-4d42-a801-da207099689f", "LERhTgD3");
        })();
      } else if (configCode === "onair.es") {
        (function () {
          function i(e) {
            if (!window.frames[e]) {
              if (document.body && document.body.firstChild) {
                var t = document.body;
                var n = document.createElement("iframe");
                n.style.display = "none";
                n.name = e;
                n.title = e;
                t.insertBefore(n, t.firstChild);
              } else {
                setTimeout(function () {
                  i(e);
                }, 5);
              }
            }
          }
          function e(n, o, r, f, s) {
            function e(e, t, n, i) {
              if (typeof n !== "function") {
                return;
              }
              if (!window[o]) {
                window[o] = [];
              }
              var a = false;
              if (s) {
                a = s(e, i, n);
              }
              if (!a) {
                window[o].push({ command: e, version: t, callback: n, parameter: i });
              }
            }
            e.stub = true;
            e.stubVersion = 2;
            function t(i) {
              if (!window[n] || window[n].stub !== true) {
                return;
              }
              if (!i.data) {
                return;
              }
              var a = typeof i.data === "string";
              var e;
              try {
                e = a ? JSON.parse(i.data) : i.data;
              } catch (t) {
                return;
              }
              if (e[r]) {
                var o = e[r];
                window[n](
                  o.command,
                  o.version,
                  function (e, t) {
                    var n = {};
                    n[f] = { returnValue: e, success: t, callId: o.callId };
                    if (i.source) {
                      i.source.postMessage(a ? JSON.stringify(n) : n, "*");
                    }
                  },
                  o.parameter
                );
              }
            }
            if (typeof window[n] !== "function") {
              window[n] = e;
              if (window.addEventListener) {
                window.addEventListener("message", t, false);
              } else {
                window.attachEvent("onmessage", t);
              }
            }
          }
          e("__tcfapi", "__tcfapiBuffer", "__tcfapiCall", "__tcfapiReturn");
          i("__tcfapiLocator");
          (function (e, r) {
            var t = document.createElement("link");
            t.rel = "preconnect";
            t.as = "script";
            var n = document.createElement("link");
            n.rel = "dns-prefetch";
            n.as = "script";
            var i = document.createElement("script");
            i.id = "spcloader";
            i.type = "text/javascript";
            i["async"] = true;
            i.charset = "utf-8";
            var o =
              "https://sdk.privacy-center.org/" +
              e +
              "/loader.js?target_type=notice&target=" +
              r;
            if (window.didomiConfig && window.didomiConfig.user) {
              var a = window.didomiConfig.user;
              var c = a.country;
              var d = a.region;
              if (c) {
                o = o + "&country=" + c;
                if (d) {
                  o = o + "&region=" + d;
                }
              }
            }
            t.href = "https://sdk.privacy-center.org/";
            n.href = "https://sdk.privacy-center.org/";
            i.src = o;
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(t, s);
            s.parentNode.insertBefore(n, s);
            s.parentNode.insertBefore(i, s);
          })("6ccf1587-781f-445e-90f8-ab7a44b8042f", "zNQPiEPB");
        })();
      } else if (configCode === "onair.pt") {
        (function () {
          function i(e) {
            if (!window.frames[e]) {
              if (document.body && document.body.firstChild) {
                var t = document.body;
                var n = document.createElement("iframe");
                n.style.display = "none";
                n.name = e;
                n.title = e;
                t.insertBefore(n, t.firstChild);
              } else {
                setTimeout(function () {
                  i(e);
                }, 5);
              }
            }
          }
          function e(n, o, r, f, s) {
            function e(e, t, n, i) {
              if (typeof n !== "function") {
                return;
              }
              if (!window[o]) {
                window[o] = [];
              }
              var a = false;
              if (s) {
                a = s(e, i, n);
              }
              if (!a) {
                window[o].push({ command: e, version: t, callback: n, parameter: i });
              }
            }
            e.stub = true;
            e.stubVersion = 2;
            function t(i) {
              if (!window[n] || window[n].stub !== true) {
                return;
              }
              if (!i.data) {
                return;
              }
              var a = typeof i.data === "string";
              var e;
              try {
                e = a ? JSON.parse(i.data) : i.data;
              } catch (t) {
                return;
              }
              if (e[r]) {
                var o = e[r];
                window[n](
                  o.command,
                  o.version,
                  function (e, t) {
                    var n = {};
                    n[f] = { returnValue: e, success: t, callId: o.callId };
                    if (i.source) {
                      i.source.postMessage(a ? JSON.stringify(n) : n, "*");
                    }
                  },
                  o.parameter
                );
              }
            }
            if (typeof window[n] !== "function") {
              window[n] = e;
              if (window.addEventListener) {
                window.addEventListener("message", t, false);
              } else {
                window.attachEvent("onmessage", t);
              }
            }
          }
          e("__tcfapi", "__tcfapiBuffer", "__tcfapiCall", "__tcfapiReturn");
          i("__tcfapiLocator");
          (function (e, r) {
            var t = document.createElement("link");
            t.rel = "preconnect";
            t.as = "script";
            var n = document.createElement("link");
            n.rel = "dns-prefetch";
            n.as = "script";
            var i = document.createElement("script");
            i.id = "spcloader";
            i.type = "text/javascript";
            i["async"] = true;
            i.charset = "utf-8";
            var o =
              "https://sdk.privacy-center.org/" +
              e +
              "/loader.js?target_type=notice&target=" +
              r;
            if (window.didomiConfig && window.didomiConfig.user) {
              var a = window.didomiConfig.user;
              var c = a.country;
              var d = a.region;
              if (c) {
                o = o + "&country=" + c;
                if (d) {
                  o = o + "&region=" + d;
                }
              }
            }
            t.href = "https://sdk.privacy-center.org/";
            n.href = "https://sdk.privacy-center.org/";
            i.src = o;
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(t, s);
            s.parentNode.insertBefore(n, s);
            s.parentNode.insertBefore(i, s);
          })("6ccf1587-781f-445e-90f8-ab7a44b8042f", "zNQPiEPB"); // Config Didomi ID Portugal
        })();
      } else {
        (function () {
          function r(e) {
            if (!window.frames[e]) {
              if (document.body && document.body.firstChild) {
                var t = document.body;
                var n = document.createElement("iframe");
                n.style.display = "none";
                n.name = e;
                n.title = e;
                t.insertBefore(n, t.firstChild);
              } else {
                setTimeout(function () {
                  r(e);
                }, 5);
              }
            }
          }
          function e(n, a, o, c, d) {
            function e(e, t, n, r) {
              if (typeof n !== "function") {
                return;
              }
              if (!window[a]) {
                window[a] = [];
              }
              var i = false;
              if (d) {
                i = d(e, r, n);
              }
              if (!i) {
                window[a].push({ command: e, version: t, callback: n, parameter: r });
              }
            }
            e.stub = true;
            e.stubVersion = 2;
            function t(r) {
              if (!window[n] || window[n].stub !== true) {
                return;
              }
              if (!r.data) {
                return;
              }
              var i = typeof r.data === "string";
              var e;
              try {
                e = i ? JSON.parse(r.data) : r.data;
              } catch (t) {
                return;
              }
              if (e[o]) {
                var a = e[o];
                window[n](
                  a.command,
                  a.version,
                  function (e, t) {
                    var n = {};
                    n[c] = { returnValue: e, success: t, callId: a.callId };
                    if (r.source) {
                      r.source.postMessage(i ? JSON.stringify(n) : n, "*");
                    }
                  },
                  a.parameter
                );
              }
            }
            if (typeof window[n] !== "function") {
              window[n] = e;
              if (window.addEventListener) {
                window.addEventListener("message", t, false);
              } else {
                window.attachEvent("onmessage", t);
              }
            }
          }
          e(
            "__tcfapi",
            "__tcfapiBuffer",
            "__tcfapiCall",
            "__tcfapiReturn"
          );
          r("__tcfapiLocator");
          (function (e, t) {
            var n = document.createElement("link");
            n.rel = "preconnect";
            n.as = "script";
            var r = document.createElement("link");
            r.rel = "dns-prefetch";
            r.as = "script";
            var i = document.createElement("script");
            i.id = "spcloader";
            i.type = "text/javascript";
            i["async"] = true;
            i.charset = "utf-8";
            var a =
              "https://sdk.privacy-center.org/" +
              e +
              "/loader.js?target_type=notice&target=" +
              t;
            if (window.didomiConfig && window.didomiConfig.user) {
              var o = window.didomiConfig.user;
              var c = o.country;
              var d = o.region;
              if (c) {
                a = a + "&country=" + c;
                if (d) {
                  a = a + "&region=" + d;
                }
              }
            }
            n.href = "https://sdk.privacy-center.org/";
            r.href = "https://sdk.privacy-center.org/";
            i.src = a;
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(n, s);
            s.parentNode.insertBefore(r, s);
            s.parentNode.insertBefore(i, s);
          })("af22b044-c2d8-4d42-a801-da207099689f", "G3gP2QAP");
        })();
      }

      // Notify parent component when Didomi is ready
      if (onDidomiReady) {
        onDidomiReady();
      }
    };

    initializeDidomi();
  }, [configCode, onDidomiReady]);

  return null; // No visual rendering
}

export default PrivacyDidomi;
